export const FETCH_PRODUCT = 'productPage/FETCH_PRODUCT';
